import { render, staticRenderFns } from "./Productslist.vue?vue&type=template&id=1fe01c7b&scoped=true&"
import script from "./Productslist.vue?vue&type=script&lang=js&"
export * from "./Productslist.vue?vue&type=script&lang=js&"
import style0 from "./Productslist.vue?vue&type=style&index=0&id=1fe01c7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe01c7b",
  null
  
)

export default component.exports